import { Dispatch, ReactNode, SetStateAction } from 'react';

import Close from '../../../assets/Close.svg';
import { useSideMenuContext } from '../../../context/useSideMenu';
import { returnIcon } from '../../../utils/returnIcon';
import { ContainerOverlayModal, ContentModal, ContentInfo } from './styles';

export interface IModal {
  isOpen: boolean;
  closeModal: Dispatch<SetStateAction<boolean>>;
  titleModal: string;
  option: any;
  medium?: boolean;
  headerAction?: ReactNode;
}

export const ModalInfoTemplete = ({
  children,
  closeModal,
  isOpen,
  titleModal,
  option,
  medium,
  headerAction,
}: any) => {
  const { sideMenuWidth } = useSideMenuContext();

  const RenderHeader = () => {
    const iconSrc = returnIcon({ option });
    return (
      <header>
        <div>
          {iconSrc && <img src={iconSrc} alt="" />}
          <span>{titleModal}</span>
        </div>
        {headerAction}
        <img
          className="header-filter-close-button"
          src={Close}
          onClick={() => closeModal(false)}
        />
      </header>
    );
  };
  return (
    <ContainerOverlayModal
      isOpen={isOpen}
      id="container-overlay-modal"
      width={sideMenuWidth}
    >
      <ContentModal medium={medium} isOpen={isOpen} periodic={isOpen}>
        <div className="not-showed-modal">
          <RenderHeader />
          <ContentInfo>{children}</ContentInfo>
        </div>
      </ContentModal>
    </ContainerOverlayModal>
  );
};
